import styled from 'styled-components';

import { colors } from '../../styles/colors';

import { ButtonProps } from './index';

export const ButtonStyled = styled.button<ButtonProps>`
	padding: ${({ padding }) => padding ?? '9px 60px'};
	border-radius: 8px;
	font-size: 0.95rem;
	font-weight: bolder;
	display: inline-block;
	width: ${({ width }) => width ?? 'auto'};
	border: ${({ border }) => border ?? 'none'};
	cursor: pointer;
	background-color: ${({ color }) => color ?? colors.primary};
	color: ${({ textColor }) => textColor ?? 'black'};
	&:hover {
		text-decoration: none;
		transition: all 0.5s;
		background-color: ${({ hoverColor }) => hoverColor ?? colors.primaryHover};
	}
`;
